import { useContext, useEffect } from 'react'

import { LiveJobsContext } from 'components'
import { Job } from 'types/Job'

// Will run callback everytime a new job has failed or is ready
const useLiveJobs = (callback: (job: Job) => void): void => {
  const liveJob = useContext(LiveJobsContext)

  useEffect(() => {
    if (liveJob) {
      callback(liveJob)
    }
  }, [callback, liveJob])
}

export default useLiveJobs
